import { render, staticRenderFns } from "./LncRNA.vue?vue&type=template&id=089b2202"
import script from "./LncRNA.vue?vue&type=script&lang=js"
export * from "./LncRNA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports